import moment from 'moment'
import actions from './actions'
import r2rServicesClient from 'common/utils/r2rServicesClient'
import types from '../types'
import { currenciesEndpoint } from 'common/utils/paths'
import { logGaNonInteractionEvent } from 'common/utils/analytics'
import { getSupportedLanguageCodes } from 'common/utils/context'
import { updateFooterLanguage } from 'common/utils/footer'
import { buildUrl, getDebugFlagsFromUrl } from 'tickets/utils/urlUtils'
import { getLanguageCode } from 'tickets/redux/modules/user/selectors'
import {
  getSearchOrigin,
  getSearchDestination,
  getSearchOutboundDateTime,
  getSearchInboundDateTime,
  getSearchPax,
  getCurrentModeId,
} from 'tickets/redux/modules/router/selectors'
import locationOperations from 'tickets/redux/modules/location/operations'
import GeocoderResult from 'tickets/utils/geocoderResult'
import history from 'common/utils/history'

const currencyChanged = actions.currencyChanged

const languageChanged = (language) => (dispatch, getState) => {
  const state = getState()

  if (languageHasChanged(language, state) && languageIsSupported(language)) {
    dispatch(actions.languageChanged(language))
    dispatch(fetchCurrencies())

    dispatch(updateSearchParams(language))
  }
}

const languageHasChanged = (language, state) => {
  const currentLanguage = getLanguageCode(state)
  return currentLanguage != language
}

const languageIsSupported = (language) => {
  const supportedLanguages = getSupportedLanguageCodes()
  if (supportedLanguages && supportedLanguages.find((code) => code == language)) {
    return true
  }
  return false
}

const updateSearchParams = (languageCode) => (dispatch, getState) => {
  const state = getState()
  const currentOrigin = getSearchOrigin(state)
  const currentDestination = getSearchDestination(state)

  Promise.all([
    GeocoderResult.getGeocoderResult(currentOrigin, languageCode),
    GeocoderResult.getGeocoderResult(currentDestination, languageCode),
  ])
  .then(places => {
    const origin = places[0]
    const destination = places[1]

    dispatch(locationOperations.changeOriginLongName(origin.longName))
    dispatch(locationOperations.changeOriginShortName(origin.shortName))
    dispatch(locationOperations.changeDestinationLongName(destination.longName))
    dispatch(locationOperations.changeDestinationShortName(destination.shortName))

    updateUrlLanguageCode(origin.canonicalName, destination.canonicalName, languageCode, getState())
    updateFooterLanguage(languageCode)
  })
}

const updateUrlLanguageCode = (originCanonical, destinationCanonical, languageCode, state) => {
  const oDateTime = getSearchOutboundDateTime(state)
  const iDateTime = getSearchInboundDateTime(state)
  const pax = getSearchPax(state)
  const debugFlags = getDebugFlagsFromUrl()
  const mode = getCurrentModeId(state)

  const url = buildUrl(
    originCanonical,
    destinationCanonical,
    moment(oDateTime),
    iDateTime ? moment(iDateTime) : null,
    pax,
    debugFlags,
    languageCode,
    mode,
  )

  history.replace(url)
}

let currenciesPromise = null
const fetchCurrencies = () => (dispatch) => {
  if (currenciesPromise == null) {
    currenciesPromise = new Promise(
      (resolve, reject) => {
        r2rServicesClient.get(currenciesEndpoint, {
          params: {
            key: '86f5qBa1',
          },
        })
        .then((response) => {
          dispatch({
            type: types.CURRENCY_DATA_RECEIVED,
            payload: response.data,
          })
          logGaNonInteractionEvent(
            'Tickets', 'API:Currency', 'Success'
          )
          resolve()
        })
        .catch((error) => {
          logGaNonInteractionEvent(
            'Tickets', 'API:Currency', `Error:${error}`
          )
          reject()
        })
      }
    )
  }
  return currenciesPromise
}

export default {
  currencyChanged,
  fetchCurrencies,
  languageChanged,
}
